import { getOnlineBankingAccounts, getOnlineBankingBanks, postOnlineBankingPayout } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/utils/i18n';
import { debug } from 'util';

Vue.use(Vuex);

const state = {
  selectedBankAccount: {},
  AccountNumber: null,
  file: {},
  bank: null,
  banks: [],
  accounts: [],
  online_banking_card_id: -1,
  verificationCode: '',
  cod_transaction: null,
  verificationCodeModel: {},
  verificationCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
  payoutCompleteCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  setPayoutCompleteCodeStatus(state, row) {
    state.payoutCompleteCodeStatus = {
      ...state.payoutCompleteCodeStatus,
      ...row,
    };
  },
  setBanks(state, cols) {
    state.banks = cols;
  },
  setAccounts(state, cols) {
    state.accounts = cols;
  },
  setCodTransaction(state, val) {
    state.cod_transaction = val;
  },
};

const actions = {
  tryGetOnlineBankingBankAccounts({ commit }) {
    getOnlineBankingAccounts().then(r => {
      if (r.data.IsSuccess) {
        commit('setAccounts', r.data.Data);
      }
    });
  },
  tryGetOnlineBankingBanks({ commit }) {
    getOnlineBankingBanks().then(r => {
      if (r.data.IsSuccess) {
        commit('setBanks', r.data.Data);
      }
    });
  },
  tryPostOnlineBankingPayout({ commit, dispatch }, formData) {
    commit('setPayoutCompleteCodeStatus', { loading: true });
    postOnlineBankingPayout(formData).then(r => {
      if (r.data.IsSuccess) {
        if (r.data.Data.status === 'OK') {
          dispatch('payoutStore/tryGetPendingPayouts', null, { root: true });
          commit('setCodTransaction', r.data.Data.payout.cod_transaction);
          commit('setPayoutCompleteCodeStatus', {
            success: true,
            error: false,
          });
        } else {
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            error: i18n.t('Exceptions.' + r.data.Data.error_code || r.data.Data.message),
          });
        }
      } else {
        if (r.data.ExceptionMessage[0] === 'ROLLOVER_REACHED') {
          commit('payoutStore/setRollover', { error: true }, { root: true });
        } else {
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            error: r.data.ExceptionMessage[0],
          });
        }
      }
      commit('setPayoutCompleteCodeStatus', { loading: false });
      dispatch('player/tryGetBalance', null, { root: true });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
